var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33331 11.5C3.33331 9.61438 3.33331 8.67157 3.9191 8.08579C4.50489 7.5 5.44769 7.5 7.33331 7.5H12.6666C14.5523 7.5 15.4951 7.5 16.0809 8.08579C16.6666 8.67157 16.6666 9.61438 16.6666 11.5V11.5C16.6666 14.3284 16.6666 15.7426 15.788 16.6213C14.9093 17.5 13.4951 17.5 10.6666 17.5H9.33331C6.50488 17.5 5.09067 17.5 4.21199 16.6213C3.33331 15.7426 3.33331 14.3284 3.33331 11.5V11.5Z",
    stroke: "#344054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6.66667V5.83333C13.3333 3.99239 11.8409 2.5 9.99996 2.5V2.5C8.15901 2.5 6.66663 3.99239 6.66663 5.83333V6.66667",
    stroke: "#344054",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99998,
    cy: 12.5,
    r: 1.66667,
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.44d2d241a3ae6f87187a7e38941971c5.svg";
export { ForwardRef as ReactComponent };